export default __webpack_public_path__ + "static/media/HOME-banner.c367da19.png";